export const slideUp = (target, duration = 500, isSearchable = false) => {
	return new Promise((resolve) => {
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		void target.offsetHeight;
		target.style.overflow = 'hidden';
		['height', 'paddingTop', 'paddingBottom', 'marginTop', 'marginBottom'].forEach((prop) => {
			target.style[prop] = 0;
		});
		window.setTimeout(() => {
			if (!isSearchable) {
				target.style.display = 'none';
			}
			['height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom', 'overflow', 'transition-duration', 'transition-property'].forEach((prop) =>
				target.style.removeProperty(prop),
			);
			resolve();
		}, duration);
	});
};

export const slideDown = (target, duration = 500, isSearchable = false) => {
	return new Promise((resolve) => {
		if (!isSearchable) {
			target.style.removeProperty('display');
			let display = window.getComputedStyle(target).display;
			if (display === 'none') display = 'block';
			target.style.display = display;
		}
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		['height', 'paddingTop', 'paddingBottom', 'marginTop', 'marginBottom'].forEach((prop) => {
			target.style[prop] = 0;
		});
		void target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		['padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach((prop) => target.style.removeProperty(prop));
		window.setTimeout(() => {
			['height', 'overflow', 'transition-duration', 'transition-property'].forEach((prop) => target.style.removeProperty(prop));
			resolve();
		}, duration);
	});
};

export const slideToggle = (target, duration = 500) =>
	window.getComputedStyle(target).display === 'none' ? slideDown(target, duration) : slideUp(target, duration);
